import { ReactComponent as DownloadIcon } from './download.svg';

export default DownloadIcon;
